const API_BASEURL   = process.env.NEXT_PUBLIC_API_BASEURL;
const IMAGE_BASEURL = process.env.NEXT_PUBLIC_IMG_BASEURL;
const NODE_ENV      = process.env.NEXT_PUBLIC_NODE_ENV;
const WEBSITE_URL   = process.env.NEXT_PUBLIC_WEBSITE_URL;

export { API_BASEURL, IMAGE_BASEURL, NODE_ENV, WEBSITE_URL };
